var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var GLOBAL_DEFAULTS = {
    test: false,
};
var CONFIG = {
    localhost: __assign(__assign({}, GLOBAL_DEFAULTS), { restAPIUrl: 'https://apigateway.integration.misp-solutions.com/changelogs/changelog', test: true }),
    dev: __assign(__assign({}, GLOBAL_DEFAULTS), { restAPIUrl: '' }),
    test: __assign(__assign({}, GLOBAL_DEFAULTS), { googleMapsApiKey: 'AIzaSyBDoZRdW4nlR88lNTU6I5OOFAWNZASEqyk', restAPIUrl: '' }),
    staging: __assign(__assign({}, GLOBAL_DEFAULTS), { restAPIUrl: '' }),
    prod: __assign(__assign({}, GLOBAL_DEFAULTS), { restAPIUrl: '' }),
};
// eslint-disable-next-line import/no-mutable-exports
var config;
if (window.location.hostname.includes('localhost') || window.location.hostname.includes('.chaos')) {
    config = CONFIG.localhost;
}
else if (window.location.hostname.includes('-dev.')) {
    config = CONFIG.dev;
}
else if (window.location.hostname.includes('-test.')) {
    config = CONFIG.test;
}
else if (window.location.hostname.includes('-staging.')) {
    config = CONFIG.staging;
}
else {
    config = CONFIG.prod;
}
export default config;
//# sourceMappingURL=global-variables.js.map